import { axiosWithToken } from 'libs/configureAxios'
import { BasicResponse } from 'types/conmon'
import { NewsType } from 'services/newServices/newServices.type'

/**
 * Admin Services for admin-specific endpoints
 */
export class AdminServices {
  /**
   * Get news detail for admin users (for cache management)
   */
  async getNewsDetail(params: {
    id: string
    list_news_ai_id?: string
  }): Promise<BasicResponse<NewsType>> {
    const queryParams = params.list_news_ai_id
      ? `?list_news_ai_id=${params.list_news_ai_id}`
      : ''
    return (
      await axiosWithToken.get(`/v1/admin/news/${params.id}${queryParams}`)
    ).data
  }
}
